export const NOTIFICATION_SERVICE = 'notification_service';

export default function notificationsServiceFactory(services) {

  let thisService = {
    init,
    getNotificationsAsync,
    dismiss,
    dismissAll,
    subscribe,
    promptForBrowserNotifications,
  };

  activate();

  return thisService;

  ////////////////////

  function activate() {
    services.window.addEventListener('webNotificationRequest', webNotificationsAuthChangedExternally);
    // ui.events.$on('webNotificationsRequest', webNotificationsAuthChangedExternally);
  }

  // An init method is required because app.getCurrentAppId() gets called through pusher subscriptions,
  // which can cause the wrong appId to be returned. We need to fix this sequencing more holistically.
  function init() {
    if (!services.session.isOrphan() && browserNotificationsGranted()) {
      subscribe(browserNotification);
    }
  }

  function getNotificationsAsync(limit = 50, offset = 0) {
    let config = {
      params: {
        id: 'current',
        limit: limit,
        offset: offset,
      }
    };
    return services.http.get(NOTIFICATION_SERVICE, 'event', config)
      .then(resp => {
        return resp.data;
      })
      .catch(e => {
        console.warn('Error getting notifications', e);
        return Promise.reject(e);
      });
  }

  function dismiss(notification) {
    let acknowledgeLink = notification._links?.acknowledge;
    if (!acknowledgeLink) {
      return Promise.reject('Unable to dismiss because no "acknowledge" link');
    }
    let config = {
      method: acknowledgeLink.op,
    };
    return services.http.serviceRequest(NOTIFICATION_SERVICE, acknowledgeLink.href, config);
  }

  function dismissAll(dismissAllLink) {
    if (!dismissAllLink) {
      return Promise.reject('Unable to dismiss all because no "acknowledgeAll" link');
    }
    let config = {
      method: dismissAllLink.op,
    };
    return services.http.serviceRequest(NOTIFICATION_SERVICE, dismissAllLink.href, config);
  }

  function subscribe(callback) {
    return getPusherChannelAsync().then(pusherChannel => {
      services.pusher.bind(pusherChannel, 'AnyEvent', event => {
        let myEvent = typeof event === 'string' ? JSON.parse(event) : event;
        myEvent = correctNotificationEventTimestamp(myEvent);
        // Notifications come across pusher with the wrong format due to server issue
        if (!myEvent._links) {
          myEvent._links = myEvent.links;
        }

        callback(myEvent);
      });
    })
      .catch(e => {
        console.warn('Error subscribing to notifications pusher channel', e);
      });
  }

  async function handlePusherEvent(event) {

  }

  function getPusherChannelAsync() {
    let config = {
      params: {
        limit: 0,
        offset: 0,
      },
      cache: true,
    };
    let url = services.session.getRegistryService('notification_service').sv_url + '/';
    return services.session.HTTPFetch(url, config).then(resp => {
      return resp.data.privatePusherChannel;
    })
      .catch(e => {
        return Promise.reject(e);
      });
  }

  function correctNotificationEventTimestamp(event) {
    //Only correct the timestamp if we haven't already somewhere else
    if (!event.unixTimeStamp) {
      // Adjust for time skew between client and server
      // Most times this should be very small if at all
      let clientCurrentTime = Date.now();
      if (event.timestamp > clientCurrentTime) {
        event.timestamp = clientCurrentTime;
      }

      //Setting this so we know we've corrected the timestamp already
      event.unixTimeStamp = event.timestamp;
    }
    return event;
  }

  function promptForBrowserNotifications() {
    if (browserSupportsNotifications()) {
      if (Notification.permission === 'default') {
        Notification.requestPermission(permission => {
          if (permission === 'granted') {
            subscribe(browserNotification);
            services.preferences.setPreferenceAsync('browserNotifications', true, 'notifications');
          }
          services.ga.eventTrack('notifications', 'notifications api authorization change', permission);
        });
      }
    }
  }

  function browserSupportsNotifications() {
    return 'Notification' in window;
  }

  function browserNotificationsGranted() {
    return browserSupportsNotifications() && Notification.permission === 'granted';
  }

  function isDismissedNotification(notification) {
    switch (notification.eventDescriptionId) {
      case 'EVENT_DISMISSED':
      case 'EVENT_DISMISSED_ALL':
        return true;
      default:
        return false;
    }
  }

  function browserNotification(notification) {
    if (isDismissedNotification(notification)) {
      return;
    }

    let prefs = services.preferences.getPreferences();
    if (browserNotificationsGranted()) {
      // The undefined case covers the situation after integrating Notifications phase 2: users who have
      // already granted permission but who do not yet have a 'browser notifications' preference set to true.
      if (prefs.notifications?.browserNotifications ? prefs.notifications.browserNotifications : true) {
        if (prefs.notifications?.browserNotifications === undefined ) {
          services.preferences.setPreferenceAsync('browserNotifications', true, 'notifications');
        }

        let title = notification.title ? services.i18n.tryTranslate('notification', notification.title) : '???';
        let body = '';

        if (notification.linkTitle) {
          body += services.i18n.tryTranslate('notification', notification.linkTitle) + ': ';
        }
        if (notification.linkLabel) {
          body += services.i18n.tryTranslate('notification', notification.linkLabel);
        }

        body += '\n';

        if (notification.subLabel) {
          body += services.i18n.tryTranslate('notification', notification.subLabel) + ': ';
        }
        if (notification.subValue) {
          body += services.i18n.tryTranslate('notification', notification.subValue, notification.subValueParams);
        }

        let options = {
          body: body,
          icon: 'https://cdn.printos.com/images/printos-blue.png',
          tag: notification.id,
        };

        let n = new Notification(title, options);
        n.onclick = (event) => {
          event.preventDefault();
          services.ga.eventTrack('notifications', 'notification clicked', notification.title);
          return services.go.toContext(notification.linkValue, notification.entityId);
        };
      }
    }
  }

  function webNotificationsAuthChangedExternally() {
    if (Notification.permission === 'granted') {
      subscribe(browserNotification);
    }

    // Update cached preferences
    services.preferences.getPreferences(false);
  }
}


